// extracted by mini-css-extract-plugin
module.exports = {"video-section__heading":"video-section_video-section__heading__7Kxth","video-section__text":"video-section_video-section__text__q_sif"};